import { Header } from './Header';

export default function Layout({ children }: any) {
	return (
		<div>
			<Header />
			{children}
      <Footer />
		</div>
	);
}

function Footer () {
  return (
    <div className="footer">
      <h6>Sistema de Ordenamiento Territorial - 2022</h6>
    </div>
  )
}

